import StructureLabel from 'LuxKit/Label/StructureLabel'
import switchFunc from 'lib/function/switchFunc'
import { useMemo } from 'react'
import useInsuranceLabels from 'hooks/Insurance/useInsuranceLabels'

const cabinToLabelVariant = switchFunc<React.ComponentProps<typeof StructureLabel>['variant'], string>({
  Business: 'dark',
  First: 'exclusive',
}, 'premium')

interface Props {
  fareFamily: App.FlightFareFamily
}

function FareFamilyClassLabel(props: Props) {
  const { fareFamily } = props
  const { protectedFlightsName } = useInsuranceLabels()

  const label = useMemo(() => {
    const description = fareFamily.fareFamily.description
    if (fareFamily.withEmbeddedInsurance) {
      return protectedFlightsName
    }
    return description
  }, [fareFamily.fareFamily.description, fareFamily.withEmbeddedInsurance, protectedFlightsName])

  return (<StructureLabel
    variant={cabinToLabelVariant(fareFamily.cabin)}
  >
    {label}
  </StructureLabel>)
}

export default FareFamilyClassLabel
